module.exports = "https://static.im-cdn.com/mjc/storefront/Cipher/static/media/security-seals.46e6f09d.png";